var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDesktop)?_c('div',{staticClass:"main-header"},[_c('DesktopHeader')],1):_c('div',[_c('Header')],1),_vm._t("default"),(_vm.isDesktop)?_c('div',[_c('Footer')],1):_c('div',[_c('MobileFooter')],1),_c('PopupLogin')],2)}
var staticRenderFns = []

export { render, staticRenderFns }